import { getScaleImageSrc } from 'wix-rich-content-common/libs/imageUtils';
import loadable from '@loadable/component';
import React, { useMemo } from 'react';
import { Node_Type } from 'ricos-types';

function getRandomValue(pool) {
  return pool[Math.floor(Math.random() * pool.length)];
}
function toBackgroundString(background, backgroundType, width, height) {
  var _a, _b;
  switch (backgroundType) {
    case BACKGROUND_TYPES.GRADIENT:
      try {
        var gradient = background.gradient;
        return "linear-gradient(" + gradient.angle + "deg, " + gradient.startColor + ", " + gradient.lastColor + ")";
      } catch (error) {
        console.error(error);
        return background;
      }
    case BACKGROUND_TYPES.IMAGE:
      if (!width || !height) {
        return null;
      }
      var URL = (_b = (_a = background.image) == null ? void 0 : _a.src) == null ? void 0 : _b.url;
      var imageSrc = getScaleImageSrc(URL, width, height);
      return "url('" + imageSrc + "') center / cover";
    case BACKGROUND_TYPES.COLOR:
    default:
      return background.color;
  }
}

var _BACKGROUND_PRESETS;
var LAYOUTS = {
  LIST: "LIST",
  GRID: "GRID"
};
var BACKGROUND_TYPES = /* @__PURE__ */function (BACKGROUND_TYPES2) {
  BACKGROUND_TYPES2["COLOR"] = "COLOR";
  BACKGROUND_TYPES2["IMAGE"] = "IMAGE";
  BACKGROUND_TYPES2["GRADIENT"] = "GRADIENT";
  return BACKGROUND_TYPES2;
}(BACKGROUND_TYPES || {});
var BACKGROUND_PRESETS = (_BACKGROUND_PRESETS = {}, _BACKGROUND_PRESETS["COLOR" /* COLOR */] = ["#EF4538", "#F96132", "#FAAD4D", "#31B778", "#488FFE", "#11428D", "#6C49EF", "#8C0F7A"], _BACKGROUND_PRESETS["IMAGE" /* IMAGE */] = ["https://static.wixstatic.com/media/2dfdd3_03c2331b19bb41108b34938edf8951dd~mv2.jpg", "https://static.wixstatic.com/media/2dfdd3_df028f9258cf4fe0a1b7f75a3916def1~mv2.jpg", "https://static.wixstatic.com/media/2dfdd3_b120b7d9cffd4645bb143beadef13c56~mv2.jpg", "https://static.wixstatic.com/media/2dfdd3_1977932e94064f168abaaa2c04b678a5~mv2.jpg", "https://static.wixstatic.com/media/2dfdd3_17b428ae1fb14736a2ab30994620ee62~mv2.jpg", "https://static.wixstatic.com/media/2dfdd3_934a080451cd4b3eb6e7c9485a07972c~mv2.jpg", "https://static.wixstatic.com/media/2dfdd3_0b440a1138ba4c99bc954eb4d06ec0ad~mv2.jpg", "https://static.wixstatic.com/media/2dfdd3_395a5522e3474b3ca34194633e90ea81~mv2.jpg"], _BACKGROUND_PRESETS["GRADIENT" /* GRADIENT */] = [{
  angle: 45,
  startColor: "#EF4538",
  lastColor: "#488FFE"
}, {
  angle: 45,
  startColor: "#F96132",
  lastColor: "#FAAD4D"
}, {
  angle: 45,
  startColor: "#31B778",
  lastColor: "#FAAD4D"
}, {
  angle: 45,
  startColor: "#0D6546",
  lastColor: "#31B778"
}, {
  angle: 45,
  startColor: "#488FFE",
  lastColor: "#8C0F7A"
}, {
  angle: 45,
  startColor: "#11428D",
  lastColor: "#488FFE"
}, {
  angle: 45,
  startColor: "#6C49EF",
  lastColor: "#31B778"
}, {
  angle: 45,
  startColor: "#8C0F7A",
  lastColor: "#FAAD4D"
}].map(function (value) {
  return JSON.stringify(value);
}), _BACKGROUND_PRESETS);
var OPTION_IMAGES_POOL = ["https://static.wixstatic.com/media/fb62d9f8e7824b2e90b13b971e700b92.jpg", "https://static.wixstatic.com/media/3a27828e768344158489df4f2c03cfb2.jpg"];
var POLL_IMAGES_POOL = ["https://static.wixstatic.com/media/436483e6ed9e41fe91b9f286d2ea4efb.jpg"];
var MEMBER_ROLES = {
  ALL: "ALL",
  SITE_MEMBERS: "SITE_MEMBERS"
};
var DIRECTIONS = {
  LTR: "LTR",
  RTL: "RTL"
};
var VISIBILITY_OPTIONS = {
  EVERYONE: "EVERYONE",
  VOTERS: "VOTERS",
  CREATOR: "CREATOR"
};
var DEFAULT_RICOS_COMPONENT_DATA = {
  containerData: {
    width: {
      size: "CONTENT"
    },
    alignment: "CENTER",
    textWrap: true
  },
  poll: {
    ownVotes: [],
    title: "",
    settings: {
      permissions: {
        view: VISIBILITY_OPTIONS.VOTERS,
        vote: MEMBER_ROLES.ALL,
        allowMultipleVotes: false
      },
      showVoters: true,
      showVotesCount: true
    },
    options: []
  },
  layout: {
    poll: {
      type: LAYOUTS.LIST,
      direction: DIRECTIONS.LTR,
      enableImage: true
    },
    options: {
      enableImage: false
    }
  },
  design: {
    poll: {
      background: {
        type: "IMAGE" /* IMAGE */,
        image: {
          src: {
            url: getRandomValue(BACKGROUND_PRESETS["IMAGE" /* IMAGE */])
          }
        }
      },
      borderRadius: 0
    },
    options: {
      borderRadius: 0
    }
  }
};

var POLL_TYPE = "wix-draft-plugin-poll";

var _nodeViewRenderers;
function _createForOfIteratorHelperLoose$1(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray$1(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }
function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp$1 = Object.defineProperty;
var __getOwnPropSymbols$1 = Object.getOwnPropertySymbols;
var __hasOwnProp$1 = Object.prototype.hasOwnProperty;
var __propIsEnum$1 = Object.prototype.propertyIsEnumerable;
var __defNormalProp$1 = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp$1(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues$1 = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
  if (__getOwnPropSymbols$1) {
    for (var _iterator = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum$1.call(b, prop)) __defNormalProp$1(a, prop, b[prop]);
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp$1.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols$1) {
    for (var _iterator2 = _createForOfIteratorHelperLoose$1(__getOwnPropSymbols$1(source)), _step2; !(_step2 = _iterator2()).done;) {
      var prop = _step2.value;
      if (exclude.indexOf(prop) < 0 && __propIsEnum$1.call(source, prop)) target[prop] = source[prop];
    }
  }
  return target;
};
var PollRenderer = function PollRenderer(_a) {
  var _b = _a,
    node = _b.node,
    nodeIndex = _b.nodeIndex,
    NodeViewContainer = _b.NodeViewContainer,
    props = __objRest(_b, ["node", "nodeIndex", "NodeViewContainer"]);
  var Poll = useMemo(function () {
    return loadable({
      resolved: {},
      chunkName: function chunkName() {
        return "ricos_plugin_poll";
      },
      isReady: function isReady(props) {
        var key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: function importAsync() {
        return import( /* webpackChunkName: "ricos_plugin_poll" */'./poll.js');
      },
      requireAsync: function requireAsync(props) {
        var _this = this;
        var key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(function (resolved) {
          _this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync: function requireSync(props) {
        var id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve: function resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("./poll");
        }
        return eval('require.resolve')("./poll");
      }
    });
  }, []);
  return /* @__PURE__ */React.createElement(Poll, __spreadValues$1({
    key: node.id,
    node: node,
    nodeIndex: nodeIndex,
    NodeViewContainer: NodeViewContainer
  }, props));
};
var PollLoadable = function PollLoadable(_c) {
  var _d = _c,
    node = _d.node,
    nodeIndex = _d.nodeIndex,
    NodeViewContainer = _d.NodeViewContainer,
    props = __objRest(_d, ["node", "nodeIndex", "NodeViewContainer"]);
  return /* @__PURE__ */React.createElement(PollRenderer, __spreadValues$1({
    node: node,
    nodeIndex: nodeIndex,
    NodeViewContainer: NodeViewContainer
  }, props));
};
var nodeViewRenderers = (_nodeViewRenderers = {}, _nodeViewRenderers[Node_Type.POLL] = PollLoadable, _nodeViewRenderers);

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var pluginPoll = function pluginPoll(config) {
  return {
    config: __spreadValues(__spreadValues({}, DEFAULT_RICOS_COMPONENT_DATA.containerData), config),
    type: POLL_TYPE,
    nodeViewRenderers: nodeViewRenderers
  };
};

export { LAYOUTS as L, OPTION_IMAGES_POOL as O, POLL_IMAGES_POOL as P, VISIBILITY_OPTIONS as V, POLL_TYPE as a, getRandomValue as g, pluginPoll as p, toBackgroundString as t };
